import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import AddCondidateModel from "./AddCandidateModel"
import Paginate from "../../../CommanCom/Pagination";
import Pagination from "../../../CommanCom/Pagination";
import Loader from "../../../CommanCom/Loader";
import { getNewCondidateList } from "../../../Redux/Actions/newJoinerAction";
import { useDispatch, useSelector } from "react-redux";
import { sendjoiningFrom } from './api/Calls'
import moment from "moment";
import ConfirmationAlert from "./ConfirmationModel";
import { Checkbox } from "@material-ui/core";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
const Table = () => {
    const pagination = useRef();
    const [modal, setModal] = useState(false);
    const [systemReq, setSystemReq] = useState('none');
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { condidate, loading } = useSelector((state) => state.NewJoinerReducer);
    const [currentPage, setCurrentPage] = useState(1);
    const [selected, setSelelected] = useState('');
    const [mailForm, setMailForm] = useState('');
    const [alertPopup, setAlertPopup] = useState('');
    const [userReqId, setUserReqId] = useState(''); const [OpenJoiningViewForm, setOpenJoiningViewForm] = useState([]);
    const [formOpen, setFormOpen] = useState(0);
    const [emailcheck, setEmailcheck] = useState(1);
    const [systemcheck, setSystemcheck] = useState(0);
    const [systemtype, setSystemtype] = useState('');
    useEffect(() => {
        dispatch(getNewCondidateList());
    }, [])
    const handleUpdate = (candidateItems) => {
       
        setSelelected(candidateItems);
    }

    const postPerPage = 10;
    const totalPosts = condidate?.length;

    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const filterNewCondidate = condidate?.slice(indexOfFirstPost, indexOfLastPost);

    const sendJoiningFormHandler = (condidateID) => {
        sendjoiningFrom(condidateID).then((data) => {
            if (data.status) {
                dispatch(getNewCondidateList());
                setMailForm(1);
            } else {
                setMailForm(0);
            }

        })
    }
    const openConfirmationAlert = (id) => {
        setAlertPopup(id)
    }
    const [itReq, setItReq] = useState([]);
    const [systemType, setSystemType] = useState('')
    const [osType, setOsType] = useState('')
    const handleCheckboxIt = (checkboxvValue, checked) => {
        let itReq_array = [...itReq]
        if (checked) {
            itReq_array = [...itReq, checkboxvValue]
        } else {
            itReq_array.splice(itReq.indexOf(checkboxvValue), 1);
        }
        setItReq(itReq_array)
    }
    const sendwelcomeMail = async () => {
        const response = await fetch(SERVER_URL + `api/candidate/onboarding/welcome/mail`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: itReq
                }),
            })
            .then(res => res.json())
            .then(data => {
                // console.log(data)
            })


    }
    const sendReqToIt = (id) => {
        setUserReqId(id)
        setModal(true)
    }
    const handleClose = () => {
        setUserReqId('')
        setModal(false)
    }
    const handleSysytemReqtype = (type) => {
        if (type == 1) {
            setSystemReq('block')
        } else {
            setSystemReq('none')
        }
    }
    const [err, setErr] = useState('')
    const [msg, setMsg] = useState('')
    const saveITRequest = () => {
        // alert(userReqId)
        // alert(emailcheck)
        // alert(systemcheck)
        // alert(systemtype)
        const response = fetch(SERVER_URL + 'api/employee/hrReqEmail', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                userId: userReqId,
                emailcheck: emailcheck,
                systemcheck: systemcheck,
                systemtype: systemtype,
            }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setMsg(data.msg)
                    setErr('green')
                    dispatch(getNewCondidateList());
                    setTimeout(() => {
                        setMsg('')
                        setErr('')    
                        handleClose()                    
                    }, [2000])
                } else {
                    setMsg('Something went wrong')
                    setErr('red')
                }
            });
    }

    const handleemail = (e) => {
        setEmailcheck(e.target.value)
    }
    const handlesystem = (e) => {
        setSystemcheck(e.target.value)
    }

    return (
        <>
            {formOpen === 1 ? navigate(`/view-joining-form/${OpenJoiningViewForm}`) :
                <>
                    <Modal show={modal} size="md" id="confirm_login">
                        <div className="modal-body">
                            <button type="button" className="float-end btn_close" data-bs-dismiss="modal" onClick={handleClose} aria-label="Close"    >
                                <i className="icon icon-cross"></i>
                            </button>

                            <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Request for Email</div>
                            <form>
                                <div className="mb-2">
                                    <div className="form-label">Create Mail</div>
                                    <div className="form-check d-inline-block hand">
                                        <input className="form-check-input" type="radio" name="mailstatus" id="active" onChange={handleemail} value='1' checked={emailcheck == 1} />
                                        <label className="form-check-label" htmlFor="active">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check d-inline-block hand ml20">
                                        <input className="form-check-input" type="radio" name="mailstatus" id="inactive" onChange={handleemail} value='0' checked={emailcheck == 0} />
                                        <label className="form-check-label" htmlFor="inactive">
                                            No
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <div className="form-label">System Require</div>
                                    <div className="form-check d-inline-block hand">
                                        <input className="form-check-input" type="radio" name="systemstatus" id="activesystem" onChange={handlesystem} value='1' checked={systemcheck == 1} />
                                        <label className="form-check-label" htmlFor="activesystem">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check d-inline-block hand ml20">
                                        <input className="form-check-input" type="radio" name="systemstatus" id="inactivesystem" onChange={handlesystem} value='0' checked={systemcheck == 0} />
                                        <label className="form-check-label" htmlFor="inactivesystem">
                                            No
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-2" style={{ display: `${systemcheck == 1 ? 'block' : 'none'}` }}>
                                    <label className="col-form-label">System Type</label>
                                    <select value={systemtype} onChange={e => { setSystemtype(e.target.value) }} className="form-select">
                                        <option value=''>Select system type</option>
                                        <option value='1'>Desktop</option>
                                        <option value='2'>Laptop</option>
                                    </select>
                                </div>
                            </form>
                            <div className="modalfooter">
                                <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" onClick={handleClose}>Cancel</button>
                                <button type="button" onClick={saveITRequest} className="btn_5 float-end ">Submit</button>
                                <div className="mr08 float-end mt10" style={{ color: err }}>{msg}</div>
                            </div>
                        </div>


                    </Modal >
                    <AddCondidateModel condidateDetail={selected} setSelelected={setSelelected} setModal={setModal} />
                    <ConfirmationAlert sendJoiningFormHandler={sendJoiningFormHandler} alertPopup={alertPopup} />
                    <div className="row_bg">
                        <div className="row mb30">
                            <div className="col-md-12">
                                {
                                    itReq.length > 0 && <button onClick={sendwelcomeMail} className="btn_5 mb12">Welcome Mail</button>
                                }
                                <table className="table_style_1">
                                    <thead>
                                        <tr>
                                            <th>Sr.No</th>
                                            <th style={{ width: 210 }}>Candidate Name</th>
                                            <th>Personal Email</th>
                                            <th>Contact Number	</th>
                                            <th>Date of Joining</th>
                                            <th>Status</th>
                                            <th style={{ width: 210 }}>Action</th>
                                        </tr>
                                    </thead>
                                    {loading ? (
                                        <Loader />
                                    ) : (
                                        <tbody>
                                            {
                                                filterNewCondidate?.length > 0 ?
                                                    filterNewCondidate?.map((item, keys) => { //console.log(item);
                                                        var warningClass = '';
                                                        var statusText = '';
                                                        var btnChange = '1';
                                                        if (item.onboarding_status == 0) {
                                                            warningClass = 'bg-warning';
                                                            statusText = 'Pending';
                                                            btnChange = 1
                                                        } else if (item.onboarding_status == 1) {
                                                            warningClass = 'bg-danger';
                                                            statusText = 'Request Sent';
                                                            btnChange = 1
                                                        } else if (item.onboarding_status == 2) {
                                                            warningClass = 'bg-success';
                                                            statusText = 'Inprogress';
                                                            btnChange = 1
                                                        } else if (item.onboarding_status == 3) {
                                                            warningClass = 'bg-primary';
                                                            statusText = 'HR Review';
                                                            btnChange = 3
                                                        } else if (item.onboarding_status == 4 && item.email == null) {
                                                            warningClass = 'bg-secondary';
                                                            statusText = 'Waiting for IT';
                                                            btnChange = 3
                                                        }
                                                        return (
                                                            <tr key={keys}>
                                                                <td style={{ width: 90 }}>{keys + 1}
                                                                    {/* {item.onboarding_status == 4 ? '' : <Checkbox value={item.condidateID} onChange={(e) => handleCheckboxIt(e.target.value, e.target.checked)} />} */}

                                                                </td>
                                                                <td><span className="avatar_icon">{item.first_name ? item.first_name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span> {item.first_name}</td>
                                                                <td>{item.personal_email}</td>
                                                                <td>{item.contact_no}</td>
                                                                <td>{moment(item.joining_date).format('DD-MM-YYYY')}</td>
                                                                <td>
                                                                    <span className={`badge ${warningClass} fontweight_n`}>{statusText}</span>
                                                                </td>
                                                                <td>
                                                                    <button className="btn_7 mr03" data-bs-toggle="modal" data-bs-target="#addcandidate"
                                                                        onClick={() => handleUpdate(item)}>
                                                                        Edit
                                                                    </button>
                                                                    {item.onboarding_status == 0 ? <button className="btn_7 mr03" data-bs-toggle="modal" data-bs-target="#confirm_alert" onClick={() => openConfirmationAlert(item.condidateID)} >Join Us</button> : ''}
                                                                    {item.onboarding_status == 3 ? <Link className="btn_5 mr03" to={`/viewjoiningform/?id=${item.condidateID}`} >View Form</Link> : ''}
                                                                    {item.onboarding_status == 3 ? <button onClick={() => sendReqToIt(item.condidateID)} className="btn_7 mr03">It</button> : ''}
                                                                    {/* {item.condidateID} */}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td colSpan={6} className="text-center">
                                                            <div className="notfound">No Record found</div>
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    )}
                                    {filterNewCondidate?.length > 0 ? 
                                    <tfoot>
                                            <tr>
                                                <td colSpan={7}>
                                                    {totalPosts > postPerPage && ( 
                                                        // // <Paginate
                                                        //     pageRangeDisplayed={5}
                                                        //     currentPage={currentPage}
                                                        //     setCurrentPage={setCurrentPage}
                                                        //     totalPosts={totalPosts}
                                                        //     postPerPage={postPerPage}

                                                        // />
                                                        <Pagination
                                                            currentPage={currentPage}
                                                            total={totalPosts}
                                                            limit={postPerPage}
                                                            onPageChange={(page) => setCurrentPage(page)}
                                                        />

                                                    )}
                                                </td>
                                            </tr>

                                        </tfoot>
                                        : ''} 
                                    {/* <tfoot>
                                        <tr><td colSpan="8" >
                                            <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                                            <ReactPaginate
                                                ref={pagination}
                                                pageCount={Math.ceil(totalPosts / postPerPage)}
                                                pageRangeDisplayed={4}
                                                marginPagesDisplayed={1}
                                                onPageChange={(page) => setCurrentPage(page)}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                pageLinkClassName="page-link"
                                                breakLinkClassName="page-link"
                                                nextLinkClassName="page-link"
                                                previousLinkClassName="page-link"
                                                pageClassName="page-item"
                                                breakClassName="page-item"
                                                nextClassName="page-item"
                                                previousClassName="page-item"
                                                previousLabel={<>&laquo;</>}
                                                nextLabel={<>&raquo;</>}
                                            />
                                        </td></tr>
                                    </tfoot> */}
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
export default Table;